module.exports = __webpack_public_path__ + "img/serviceplanner-offers-en.3bb14bcf.webp";